/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\HrStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 15th 2023, 5:48:08 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import styled from "styled-components";

const HrStyled = styled.hr.attrs(props => ({
    bgColor: props.bgColor,
}))`
// margin-top: -0.2rem;
margin: -0.2rem auto 0;
width: 95%;
border-top: 3px solid ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
`;

export default HrStyled;
